module.exports = __webpack_public_path__ + "img/four.7307b571.jpg";